export enum UserStatusVmEnum {
  invited = 0,
  active = 1,
  disabled = 2,
  waitingForApproval = 3
}
